import React, { Component } from 'react';

class FileInput extends Component  {
    constructor(props) {
      super(props);
     // this.handleChange = this.handleSubmit.bind(this);content-type: multipart/form-data
      this.fileInput = React.createRef();
    }

    handleChange(){
      let access_token = sessionStorage.getItem("access_token");
      let url = 'https://api.mercadolibre.com/messages/attachments?access_token=' + access_token;
      let formData = new FormData();
      formData.append("file", document.getElementById("file-input").files[0]);
      let xhr = new XMLHttpRequest();
      xhr.open("POST", url);
      xhr.addEventListener( 'load',  function () {
        let res = JSON.parse(this.responseText);
        sessionStorage.setItem("id", res.id)
      });
      //xhr.withCredentials = true;
      xhr.send(formData);
    }

    render() {
      return (
        <input type="file" id="file-input" className="btn btn-default" ref={this.fileInput} 
        onChange={ (e) => this.handleChange(e.target.files) }/>
      );
    }
  }
  
export default FileInput;